import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { PermissionGroupsService } from "../Services/PermissionGroups.service";
import { PERMISSION_GROUPS_QUERY_KEY } from "../constants";
import { ICreatePermissionGroup } from "@shared/lib/types/permissions";

export function useCreatePermissionGroup() {
  const {
    mutate: createPermissionGroup,
    isLoading: isCreating,
    isSuccess: isCreated,
    isError: isCreateFailed,
  } = useMutation({
    mutationFn: async (permissionGroup: ICreatePermissionGroup) => {
      return await PermissionGroupsService.createPermissionGroup(
        permissionGroup
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: PERMISSION_GROUPS_QUERY_KEY,
    },
    onSuccess: (c) => {},
  });

  return {
    createPermissionGroup,
    isCreating,
    isCreated,
    isCreateFailed,
  };
}
